import { render, staticRenderFns } from "./question-qa.vue?vue&type=template&id=18892653&scoped=true"
import script from "./question-qa.vue?vue&type=script&lang=js"
export * from "./question-qa.vue?vue&type=script&lang=js"
import style0 from "./question-qa.vue?vue&type=style&index=0&id=18892653&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18892653",
  null
  
)

export default component.exports